import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

const YouTubeEmbed = ({ videoUrl }) => {
    const [videoId, setVideoId] = useState('');

    useEffect(() => {
        // Extract the video ID from the YouTube share URL
        const getYouTubeVideoId = (url) => {
            const match = url?.match(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
            return match && match[1] ? match[1] : false;
        };

        const id = getYouTubeVideoId(videoUrl);
        if (id) {
            setVideoId(id);
        }
    }, [videoUrl]);

    return (

        videoId && (
            <iframe
                className="max-w-full w-full h-full "
                src={`https://www.youtube.com/embed/${videoId}`}
                title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen
            ></iframe>
        )

    );
};
YouTubeEmbed.propTypes = {
    videoUrl: PropTypes.string,
}
export default YouTubeEmbed;
